import $ from "jquery"

import {
    ObjectLoader,
    TextureLoader,
    ImageLoader,

    DefaultLoadingManager,

    MeshBasicMaterial,
    SphereGeometry,
    ConeGeometry,
    TorusKnotGeometry,

    PerspectiveCamera,

    Vector2,
    Vector3,
    Layers,
    Color,
    Group,
    Clock,
    Mesh,
    Box2,
    Box3,
    Material,
    Texture,

    RGBFormat,
    RGBAFormat,

    WebGLRenderer,
    WebGLRenderTarget,
    PCFSoftShadowMap,

    MirroredRepeatWrapping,
    Object3D,
    Light,

    Points,
    PointsMaterial,
    Float32BufferAttribute,
    BufferGeometry,
    LinearToneMapping,
    LinearEncoding,
    LinearFilter,
    FloatType,
    ShaderMaterial,

    EquirectangularReflectionMapping,
    PMREMGenerator,
    sRGBEncoding,
    MeshStandardMaterial,
    AmbientLight

} from 'three';

import { Pivot3 } from './classes/Pivot3'

import { Geometry } from 'three/examples/jsm/deprecated/Geometry'

import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';

import { SSAARenderPass } from 'three/examples/jsm/postprocessing/SSAARenderPass.js';
// import { SSRrPass } from 'three/examples/jsm/postprocessing/SSRrPass';
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass.js';
import { SAOPass } from 'three/examples/jsm/postprocessing/SAOPass.js';
import { OutlinePass } from 'three/examples/jsm/postprocessing/OutlinePass.js';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';

import { GammaCorrectionShader } from 'three/examples/jsm/shaders/GammaCorrectionShader'
import { NodePass } from 'three/examples/jsm/nodes/postprocessing/NodePass';
import { NodeFrame } from 'three/examples/jsm/nodes/core/NodeFrame';
import { FloatNode } from 'three/examples/jsm/nodes/inputs/FloatNode';
import { ScreenNode } from "three/examples/jsm/nodes/inputs/ScreenNode";
import { ColorAdjustmentNode } from "three/examples/jsm/nodes/effects/ColorAdjustmentNode";

import { CopyShader } from 'three/examples/jsm/shaders/CopyShader.js';
// import { FXAAShader } from 'three/examples/jsm/shaders/FXAAShader.js';

// import {  } from 'three/build/three.module.js';

// import { RoomEnvironment } from 'three/examples/jsm/environments/RoomEnvironment.js';
import { RoomEnvironment } from './CustomRoomEnvironment';

import CameraControls from 'camera-controls';


window.onload = function() {
    console.log(object);
    init();
};



// Variable Definitions
const basePath = 'https://aspersonal.nl/wp-content/themes/aspersonal/composer'
let camera, thumbsCamera, scene, renderer, controls, clock = new Clock()
var finalComposer, bloomComposer, activeLayers
let renderPass, ssaaRenderPass, fxaaPass, copyPass, saoPass, bloomPass, outlinePass, finalPass, nodePass, gammaCorrection, environmentMap, frame
let bloomLayer, isSomethingBlooming = false
let isSomethingOutLined = false
// const cubeCameras = []
const gltfLoader = new GLTFLoader().setPath(basePath + "/products/" + object.name + "/"),
    objectLoader = new ObjectLoader(),
    textureLoader = new TextureLoader(),
    imageLoader = new ImageLoader()
let mesh, materials
let activeStep = 0
// var canvasWidth, canvasHeight
var isLoadedOnce = false

var ENTIRE_SCENE = 0,
    BLOOM_SCENE = 2
// End Variable Definitions



// LoadingManager
DefaultLoadingManager.onLoad = () => {
    if (!isLoadedOnce) {
        isLoadedOnce = true;

        // object.steps.forEach( step => {
        //     if ( step.type == "measure" ) {

        //         mesh.scaleObject( step.default, step.direction )
        //         console.log( "titanium" )

        //     }
        // });

        // const sphere = new Mesh(new SphereGeometry(1, 32, 32), new MeshBasicMaterial({
        //     color: "#dfdfdf",
        //     transparent: true,
        //     opacity: .5
        // }))

        // mesh.add(sphere)

        updateCanvasSize();

        render();

        controls.fitObject(mesh);
        controls.goToStep(0, false);

        // createArrow( 0, 0 );

        animate();

        // mesh.scaleKeepingThickness();

        terminateLoader();
    }
};
// End LoadingManager



function init() {



    // Environment Setup
    scene = objectLoader.parse(object.scene);
    scene.background = new Color(0xffffff);


    scene.add(new AmbientLight(0));
    let random = 1;

    camera = new PerspectiveCamera();

    thumbsCamera = new PerspectiveCamera(35, 1.5);
    thumbsCamera.updateProjectionMatrix();

    // environmentMap = textureFromUrl(basePath + '/materials/utility/equirectangular-environment-map.jpg');
    // environmentMap.mapping = EquirectangularReflectionMapping;
    // environmentMap.encoding = sRGBEncoding;
    // End Environment Setup



    // Renderer
    renderer = createRenderer('.main-canvas');
    // renderer.toneMapping = THREE.ACESFilmicToneMapping;
    // renderer.toneMappingExposure = 1;
    // renderer.toneMapping = THREE.ReinhardToneMapping;
    renderer.toneMapping = LinearToneMapping;
    renderer.autoClear = false;
    // End Renderer



    // Environmentmap
    const pmremGenerator = new PMREMGenerator( renderer );
    environmentMap = pmremGenerator.fromScene( new RoomEnvironment(4, .1), 0.04 ).texture;
    environmentMap.encoding = LinearEncoding;
    scene.environment = environmentMap;
    // scene.background = environmentMap;
    // End Environmentmap

  

    // Post Proccessing



    // Render Pass
    renderPass = new RenderPass(scene, camera);
    // End Render Pass



    // SSAA Render Pass
    const renderTargetParameters = {
        minFilter: LinearFilter,
        magFilter: LinearFilter,
        format: RGBAFormat,
        type: FloatType,
        stencilBuffer: false,
    };
    const ssaaRenderTarget = new WebGLRenderTarget( window.innerWidth, window.innerHeight, renderTargetParameters );

    ssaaRenderPass = new SSAARenderPass(scene, camera);
    ssaaRenderPass.sampleLevel = 3;
    ssaaRenderPass.sampleRenderTarget = ssaaRenderTarget;
    // End SSAA Render Pass



    // // FXAA Shader Pass
    // fxaaPass = new ShaderPass(FXAAShader);
    // fxaaPass.material.uniforms['resolution'].value.set(1 / document.documentElement.offsetWidth, 1 / document.documentElement.offsetHeight);
    // // End FXAA Shader Pass


    // Copy Shader Pass
    copyPass = new ShaderPass(CopyShader);
    // End Copy Shader Pass



    // Bloom Layer
    bloomLayer = new Layers();
    bloomLayer.set(BLOOM_SCENE);
    // Bloom Layer



    // // Bloom Pass
    bloomPass = new UnrealBloomPass(new Vector2(document.documentElement.offsetWidth, document.documentElement.offsetHeight), 1.2, 0, 0); // 1.5, 0.4, 0.85
    scene.traverse(node => {
        if (node.isLight) {
            node.layers.enableAll();
        }
    })
    // // Bloom Pass



    // // Bloom Composer
    bloomComposer = new EffectComposer(renderer);
    bloomComposer.renderToScreen = false;
    bloomComposer.addPass(renderPass);
    bloomComposer.addPass(bloomPass);
    // // End Bloom Composer



    // // SSRr Pass
    // ssrrPass = new SSRrPass( {
    //     renderer,
    //     scene,
    //     camera,
    //     width: innerWidth,
    //     height: innerHeight,
    //     selects: selectedObjects
    // } );
    // ssrrPass.ior = 1.5
    // ssrrPass.output = SSRrPass.OUTPUT.Default
    // ssrrPass.ior = 1.1;
    // ssrrPass.surfDist = 0.0015;
    // ssrrPass.maxDistance = 50;
    // // End SSRr Pass


    // SAO Pass
    saoPass = new SAOPass(scene, camera, false, true);
    saoPass.params.saoIntensity = 0.0001;
    saoPass.params.saoScale = 1;
    // End SAO Pass



    // // Outline Pass
    // outlinePass = new OutlinePass( new Vector2( document.documentElement.offsetWidth, document.documentElement.offsetHeight ), scene, camera );
    // // outlinePass.enabled = false;
    // outlinePass.hiddenEdgeColor = new Color( 0, 0, 0 );
    // outlinePass.visibleEdgeColor = new Color( 0x404040 );
    // outlinePass.downSampleRatio = 2;
    // outlinePass.edgeThickness = 1.0;
    // outlinePass.edgeStrength = 3.0;
    // // outlinePass.edgeGlow = 0.0;
    // // outlinePass.pulsePeriod = 2;
    // // outlinePass.usePatternTexture = true;
    // outlinePass.patternTexture = textureFromUrl( basePath + '/utils/tri_pattern.jpg' );
    // // End Outline Pass



    // Final Pass
    finalPass = new ShaderPass(
        new ShaderMaterial({
            uniforms: {
                baseTexture: {
                    value: null
                },
                bloomTexture: {
                    value: bloomComposer.renderTarget2.texture
                }
            },
            vertexShader: `varying vec2 vUv; void main() { vUv = uv; gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 ); }`,
            fragmentShader: `uniform sampler2D baseTexture; uniform sampler2D bloomTexture; varying vec2 vUv; void main() { gl_FragColor = ( texture2D( baseTexture, vUv ) + vec4( 1.0, 1.0, 1.0, 0 ) * texture2D( bloomTexture, vUv ) ); }`,
            defines: {}
        }), "baseTexture"
    );
    finalPass.needsSwap = true
    // End Final Pass


    
    // Nodes Processing
    nodePass = new NodePass();
    frame = new NodeFrame();
    let screen = new ScreenNode();

    // const hue = new Nodes.FloatNode();
    const sataturation = new FloatNode( 1.8 );
    const vibrance = new FloatNode();
    const brightness = new FloatNode( -.03 );
    // const contrast = new Nodes.FloatNode( 1 );

    // const hueNode = new Nodes.ColorAdjustmentNode( screen, hue, Nodes.ColorAdjustmentNode.HUE );
    const satNode = new ColorAdjustmentNode( screen, sataturation, ColorAdjustmentNode.SATURATION );
    // const vibranceNode = new ColorAdjustmentNode( satNode, vibrance, ColorAdjustmentNode.VIBRANCE );
    const brightnessNode = new ColorAdjustmentNode( satNode, brightness, ColorAdjustmentNode.BRIGHTNESS );
    // const contrastNode = new Nodes.ColorAdjustmentNode( brightnessNode, contrast, Nodes.ColorAdjustmentNode.CONTRAST );

    nodePass.input = brightnessNode;
    nodePass.needsUpdate = true;
    // Nodes Processing



    // Gamma Correction Pass
    gammaCorrection = new ShaderPass( GammaCorrectionShader );
    // End Gamma Correction Pass



    // Final Composer
    const renderTarget = new WebGLRenderTarget( window.innerWidth, window.innerHeight, renderTargetParameters );
    renderTarget.texture.name = 'EffectComposer.rt1';
    finalComposer = new EffectComposer(renderer, renderTarget);
    // finalComposer.addPass( ssrrRenderPass );
    finalComposer.addPass( ssaaRenderPass );
    // finalComposer.addPass( outlinePass );
    // finalComposer.addPass( ssaaRenderPass );
    // finalComposer.addPass( fxaaPass );
    finalComposer.addPass( saoPass );
    finalComposer.addPass( nodePass );
    // finalComposer.addPass( finalPass );
    finalComposer.addPass( gammaCorrection );
    // Final Composer



    // End Post Processor



    // CameraControls
    controls = createControls(camera, renderer.domElement);
    // End CameraControls



    // Make Group
    mesh = new Group();
    scene.add(mesh);
    // End Make Group



    // Materials
    materials = objectLoader.parseMaterials(object.materials);
    object.materials.filter(material => material.subtype == "texture").forEach(material => {

        materials[material.uuid].setTexture(basePath + "/materials/" + material.library + "/" + material.default + "_512x512.jpg");
        materials[material.uuid].envMap = environmentMap

        if (material.repeatSize) {
            materials[material.uuid].map.repeat.set(...material.repeatSize);
        }

    });
    // End Materials



    // Models
    object.models.filter(model => model.initial !== false).forEach(model => {

        gltfLoader.load(model.filename, glb => {

            let scene = glb.scene;

            scene.visible = (model.visible === false) ? false : true;

            scene.traverse(function (node) {

                if ((node.isMesh || node.isLight) && !node.parent.name.includes('licht')) node.castShadow = true;
                if (node.isMesh && !node.parent.name.includes('licht')) node.receiveShadow = true;

            });

            const initiateChildrenSettings = (modelChildren, objectChildren) => {

                modelChildren.forEach(child => {
                    child.ids.forEach(child_index => {
                        objectChildren[child_index].traverse(node => {

                            if (node.isMesh) {

                        	    //   node.geometry.deleteAttribute( 'uv' );


                                if (child.material) {
                                    node.material = materials[child.material]
                                }

                                if (child.isBlooming) {
                                    node.layers.enable(BLOOM_SCENE)
                                    isSomethingBlooming = true
                                }

                                if (child.layer) {
                                    node.layers.set(child.layer)
                                }

                                if (child.ignoreResize) {
                                    node.layers.ignoreResize = child.ignoreResize
                                }

                                // if ( child.outline ) {
                                //     outlinePass.selectedObjects.push( node )
                                //     isSomethingOutLined = true
                                // }

                            }

                        });

                        if ('children' in child) initiateChildrenSettings(child.children, objectChildren[child_index].children)

                    });
                });
            }

            initiateChildrenSettings(model.children, scene.children);

            mesh.add(...scene.children);

            model.uuid = scene.uuid;
        });

    });
    // End Models



    // Steps Initializing
    object.steps.forEach( step => 
    {
        if (step.type == "model")
        {
            camera.layers.enable(step.models[0].layer);
            step.value = step.models[0].uuid;

            step.models.forEach((modelOption, index) => {

                // if (index == 0) {
                //     object.pivot = modelOption.pivot
                // }

                modelOption.renderer = createRenderer(`[model-option-uuid="${modelOption.uuid}"`, true)
                modelOption.controls = createControls(thumbsCamera, modelOption.renderer.domElement, false);

            });
        }
    });
    // End Steps Initializing



    // Window EventListener
    window.addEventListener('resize', updateCanvasSize);
    window.addEventListener('resize', () => controls.fitObject(mesh));
    // window.addEventListener( 'resize', render );
    // End Window EventListener



}
// End Init



// Update Canvas Size
function updateCanvasSize() {
    const canvasWidth = document.documentElement.offsetWidth;
    const canvasHeight = 500;

    camera.aspect = canvasWidth / canvasHeight;
    camera.updateProjectionMatrix();

    renderer.setSize(canvasWidth, canvasHeight);

    // bloomPass.setSize(canvasWidth, canvasHeight)
    saoPass.setSize(canvasWidth, canvasHeight);
    // finalPass.setSize(canvasWidth, canvasHeight)

    // bloomComposer.setSize(canvasWidth, canvasHeight);
    finalComposer.setSize(canvasWidth, canvasHeight);

    carouselItemHeights.length = 0;

    const carouselItemTopOffset = $('.carousel-inner').first().offset().top
    $('.carousel-item').each(function () {
        let scrollTop = carouselItemTopOffset + $(this).outerHeight() - window.innerHeight

        carouselItemHeights.push((scrollTop < 0) ? 0 : scrollTop)
    })

    // fxaaPass.material.uniforms['resolution'].value.x = 1 / (canvasWidth * renderer.getPixelRatio());
    // fxaaPass.material.uniforms['resolution'].value.y = 1 / (canvasHeight * renderer.getPixelRatio());
}
// End Update Canvas Size



// Animation Loop
function animate() {
    const delta = clock.getDelta();
    const updated = controls.update(delta);

    if (updated) {
        render()
    }

    requestAnimationFrame(animate);
}
// End Animation Loop



// Render
function render() {
    // renderer.render( scene, camera );
    // cubeCameras.forEach(cubeCamera => {
    //     cubeCamera.mesh.visible = false;
    //     cubeCamera.camera.update(renderer, scene);
    //     cubeCamera.mesh.visible = true;
    // });

    if (isSomethingBlooming) {
        activeLayers = camera.layers
        camera.layers.enable(BLOOM_SCENE)

        finalPass.enabled = true;

        mesh.traverse(darkenNonBloomed);
        // scene.background = new Color( 0x000000 );

        bloomComposer.render();

        // delete scene.background
        mesh.traverse(restoreMaterial);

        camera.layers.set(activeLayers);
    } else {
        finalPass.enabled = false
    }

    // if ( isSomethingOutLined ) {
    //     outlinePass.enabled = true
    // }
    // else {
    //     outlinePass.enabled = false
    // }

    finalComposer.render()

    // console.log("render")
}
// End Render



// Thumbnail Render
const renderThumbs = () => {
    const modelSteps = object.steps.filter(step => step.type == "model");
    modelSteps.forEach( modelStep => {
        modelStep.models.forEach(modelOption => {

            thumbsCamera.layers.set(0);

            modelSteps.filter( modelStep1 => modelStep1 != modelStep ).map( modelStep => { console.log( modelStep , "random125"); return modelStep.models.find( model => model.uuid == modelStep.value ).layer } ).forEach( layer =>
                thumbsCamera.layers.enable( layer )
            );
            thumbsCamera.layers.enable( modelOption.layer );

            // console.log("modelOption.controls.fitObject(mesh)", mesh);
            modelOption.controls.fitObject(mesh);
            modelOption.controls.goToStep(object.steps.indexOf(modelStep), false);
            modelOption.controls.update();
            modelOption.renderer.render(scene, thumbsCamera);

        });
    });

    selectThumb();
}

const selectThumb = () => {
    console.log("---------------");
    $('.step-indicators model-option canvas').each(function () {
        
        const modelSelectUuid = $(this).attr('model-select-uuid');
        console.log("modelSelectUuid", modelSelectUuid);
        const modelOptionUuid = object.steps.find( step => step.uuid == modelSelectUuid ).value;
        console.log("modelTargetUuid", modelOptionUuid);
        this.copyFromCanvas($(`[model-option-uuid="${modelOptionUuid}"]`)[0])
    })

    $('.step-indicators model-option.active canvas')
}
// End Thumbnail Render



// Create Renderer
const createRenderer = (canvas, antialias = false) => {
    const renderer = new WebGLRenderer({
        preserveDrawingBuffer: true,
        canvas: document.querySelector(canvas),
        alpha: true,
        antialias
    });
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = PCFSoftShadowMap;
    renderer.setPixelRatio(window.devicePixelRatio);
    return renderer;
}
// End Create Renderer



// Terminate Loader
const terminateLoader = () => {
    $(".composer-loader").css({
        opacity: 0
    }).delay(400).queue(function () {
        $(this).remove();
        $(this).dequeue();
    });
    $(".composer").css({
        opacity: 1
    });
}
// End Terminate Loader



// Create Controls
const createControls = (camera, canvas, interactive = true) => {
    const controls = new CameraControls(camera, canvas);

    if (interactive) {
        controls.mouseButtons.wheel = CameraControls.ACTION.NONE;
        controls.touches.two = CameraControls.ACTION.None;
        controls.touches.three = CameraControls.ACTION.ROTATE;
        let clearCameraFunction;

        controls.addEventListener('controlend', function () {
            clearCameraFunction = setTimeout(function () {
                // controls.fitObject( mesh, true ); // Conflicts with every step
                controls.goToStep(activeStep);
            }, 5000);
        });

        controls.addEventListener('controlstart', function () {
            if (clearCameraFunction !== undefined) {
                clearTimeout(clearCameraFunction);
                clearCameraFunction = undefined;
            }
        });
    } else {
        controls.enabled = false;
    }

    return controls
}
// End Create Contols



CameraControls.prototype.goToStep = function (stepNumber, enableTransition = true) {
    let polarAngle, azimuthAngle

    if (stepNumber < object.steps.length) {
        polarAngle = object.steps[stepNumber].controls.polarAngle
        azimuthAngle = object.steps[stepNumber].controls.azimuthAngle
    } else {
        polarAngle = object.controls.polarAngle
        azimuthAngle = object.controls.azimuthAngle
        // setTimeout(captureImage, 1200)
    }

    this.normalizeRotations();
    this.rotateTo(Math.PI / 180 * polarAngle, Math.PI / 2 - Math.PI / 180 * azimuthAngle, enableTransition)
}



CameraControls.prototype.fitObject = function (object3DOrBox3, enableTransition = false) {
    const boundingBox = (object3DOrBox3 instanceof Box3) ? object3DOrBox3 : object3DOrBox3.getBoundingBoxInLayers(this._camera.layers);

    let size = boundingBox.getSizeAlt();

    if (size.x > (size.y * 1.5)) {
        boundingBox.min.y -= (size.x / 1.5 - size.y) / 2
        boundingBox.max.y += (size.x / 1.5 - size.y) / 2
    }

    size = boundingBox.getSizeAlt();

    this.fitToBox(
        boundingBox,
        enableTransition, {
        paddingTop: size.y / 5,
        paddingBottom: size.y / 5,
        paddingLeft: size.x / 5,
        paddingRight: size.x / 5
    }
    );
}



let textureFromUrl = textureUrl => textureLoader.load(textureUrl, texture => {
    texture.wrapS = texture.wrapT = MirroredRepeatWrapping
    texture.anisotropy = renderer.capabilities.getMaxAnisotropy()
    // texture.rotation = -Math.PI/2;
    renderThumbs();
});



Material.prototype.setTexture = function (textureUrl)
{
    this.map = textureFromUrl(textureUrl);
};

MeshStandardMaterial.prototype.dithering = true;



Texture.prototype.changeImage = function (url, callback = () => { }) {
    this.image = imageLoader.load(url, image => {
        this.needsUpdate = true

        callback(image)
    });

    // JPEGs can't have an alpha channel, so memory can be saved by storing them as RGB.
    var isJPEG = url.search(/\.jpe?g($|\?)/i) > 0 || url.search(/^data\:image\/jpeg/) === 0

    this.format = isJPEG ? RGBFormat : RGBAFormat
}



Material.prototype.changeColor = function (color) {
    this.color = color

    render()
    renderThumbs()
}

const vector3Enum = {
    x: 0,
    y: 1,
    z: 2
}

const vector2Enum = {
    x: 0,
    y: 1
}

const triangleEnum = {
    a: 0,
    b: 1,
    c: 2
}

// const directionEnum = {
//     up: "up",
//     down: "down",
//     left: "left",
//     right: "right",
//     backward: "backward",
//     forward: "forward"
// }

Object3D.prototype.scaleObject = function (measure, scaleDirection, pivot = new Pivot3()) {

    measure /= 1000
    // const scaleDirectionIndex = vector3Enum[ scaleDirection ]
    const meshSize = mesh.getBoundingBoxInLayers(camera.layers).getSizeAlt()[scaleDirection]
    console.log("meshSize", meshSize);

    const pivotPointsInDirection = pivot[scaleDirection]
    let pivotPointsInDirectionCount = 2 * Math.round(pivotPointsInDirection.length / 2)

    if (scaleDirection == "y") {
        pivotPointsInDirectionCount = pivotPointsInDirection.length
    }

    const expansionInPx = measure - meshSize

    const expansionInPxPerPoint = expansionInPx / pivotPointsInDirectionCount

    console.log("expansionInPxPerPoint", expansionInPxPerPoint);

    this.traverse(node => {

        if (!(node.ignoreResize ? node.ignoreResize.includes(scaleDirection) : false)) {
            // console.log( "matrix", node.matrix )

            if (node.isMesh && node.layers.test(camera.layers)) {

                const nodeBoundingBox = node.getBoundingBox()
                const nodeSize = nodeBoundingBox.getSizeAlt()[scaleDirection]

                const localPivotPointsInDirection = []

                pivotPointsInDirection.forEach(worldPivotPointInDirection => {
                    const worldPivotPoint = new Vector3();
                    worldPivotPoint[scaleDirection] = worldPivotPointInDirection
                    const localPivotPoint = node.worldToLocal(worldPivotPoint)
                    localPivotPointsInDirection.push( localPivotPoint[scaleDirection] )
                });

                for (const [pivotPointIndex, pivotPoint] of localPivotPointsInDirection.entries()) {

                    if (pivotPoint.isBetween(nodeBoundingBox.clone().applyMatrix4( node.matrixWorld.clone().invert()  ).min[scaleDirection], nodeBoundingBox.clone().applyMatrix4( node.matrixWorld.clone().invert() ).max[scaleDirection])) {

                        console.log("node.geometry", node.geometry);

                        node.geometry.vertices.forEach((vertex, vertexIndex) => {

                            Object.keys(vertex).map(key => {

                                if (key == scaleDirection) {

                                    if (pivotPointIndex <= (localPivotPointsInDirection.length - 1) / 2 && vertex[key] < pivotPoint && scaleDirection != "y") {

                                        vertex[key] -= expansionInPxPerPoint

                                    }

                                    if ( ( pivotPointIndex >= (localPivotPointsInDirection.length - 1) / 2 || scaleDirection == "y" ) && vertex[key] > pivotPoint) {

                                        vertex[key] += expansionInPxPerPoint

                                    }

                                }

                            });

                        });

                        if (node.material.map !== null) {

                            console.log(node.geometry.faces)

                            node.geometry.faces.forEach((face, faceIndex) => {

                                if (Math.round((face.normal[scaleDirection] + Number.EPSILON) * 100) / 100 == 0) {

                                    const vertices = []

                                    Object.keys(triangleEnum).forEach(triangleIndex => {
                                        vertices.push(node.geometry.vertices[face[triangleIndex]][scaleDirection])
                                    });

                                    const sightLineIds = vertices.idsOfDoublesInTriplet()

                                    const faceVertexUvs = []

                                    sightLineIds.forEach(sightLineId => {
                                        faceVertexUvs.push(node.geometry.faceVertexUvs[0][faceIndex][sightLineId][scaleDirection])
                                    });

                                    let textureDirection = (faceVertexUvs[0] === faceVertexUvs[1]) ? "x" : "y"
                                    if (scaleDirection == "y") { // Weet niet waarom?
                                        textureDirection = (textureDirection == "x") ? "y" : "x"
                                    }

                                    const targetTextureScale = 1 + (expansionInPx / nodeSize)

                                    for (let i = 0; i < 3; i++) {
                                        node.geometry.faceVertexUvs[0][faceIndex][i][textureDirection] *= targetTextureScale
                                    }

                                }

                            });
                        }

                    } else {
                        const translation = new Vector3();

                        if (pivotPointIndex <= (localPivotPointsInDirection.length - 1) / 2 && scaleDirection != "y") { // first halve and center && not "y"

                            if (nodeBoundingBox.clone().applyMatrix4( node.matrixWorld.clone().invert()  ).max[scaleDirection] < pivotPoint) {
                                translation[scaleDirection] -= expansionInPxPerPoint
                            }

                        }

                        if (pivotPointIndex >= (localPivotPointsInDirection.length - 1) / 2 || scaleDirection == "y") { // second halve and center && "y"

                            if (nodeBoundingBox.clone().applyMatrix4( node.matrixWorld.clone().invert()  ).min[scaleDirection] > pivotPoint) {
                                translation[scaleDirection] += expansionInPxPerPoint
                            }

                        }

                        node.position[scaleDirection] += translation.applyQuaternion(node.quaternion)[scaleDirection];
                    }
                }

                node.geometry.verticesNeedUpdate = true
                // node.geometry.elementsNeedUpdate = true
                node.geometry.uvsNeedUpdate = true
                node.geometry.computeBoundingBox()

            }
        }
    });
}



Array.prototype.idsOfDoublesInTriplet = function () {
    const doubleValue = this.find((item, index) => this.indexOf(item) !== index)

    var indices = [],
        i = -1
    while ((i = this.indexOf(doubleValue, i + 1)) != -1) {
        indices.push(i)
    }
    return indices
}



Number.prototype.isBetween = function (min, max) {
    return min < this && this < max;
}



Object3D.prototype.getBoundingBox = function () {
    return new Box3().setFromObject(this);
}



Object3D.prototype.getBoundingBoxInLayers = function (layers) {

    const box3 = new Box3()

    this.traverse(node => {

        if (node.isMesh && node.layers.test(layers)) box3.expandByObject(node)

    });

    return box3

}



Object3D.prototype.computeScreenSpaceBoundingBox = function (camera) {

    let min;
    let max;

    // // Is this an array of objects?
    // if( Array.isArray( this ) ) {

    //     for( var i = 0; i < this.length; ++i ) {

    //         let box2 = this[ i ].computeScreenSpaceBoundingBox( camera );

    //         if(min === undefined) {

    //             min = box2.min.clone();
    //             max = box2.max.clone();

    //         } else {

    //             min.min(box2.min);
    //             max.max(box2.max);

    //         }

    //     }

    // }

    // Does this object have geometry?
    if (this.geometry !== undefined && this.type == "Mesh" && this.layers.test(camera.layers)) {

        console.log("isMesh", this);

        const vertices = this.geometry.vertices;
        const vertex = new Vector3();

        if (vertices === undefined && this.geometry.attributes !== undefined && 'position' in this.geometry.attributes) {

            const pos = this.geometry.attributes.position;

            for (var i = 0; i < pos.count * pos.itemSize; i += pos.itemSize) {

                vertex.set(pos.array[i], pos.array[i + 1], pos.array[1 + 2]);
                const vertexWorldCoord = vertex.applyMatrix4(this.matrixWorld);
                const vertexScreenSpace = vertexWorldCoord.project(camera);

                if (min === undefined) {

                    min = vertexScreenSpace.clone();
                    max = vertexScreenSpace.clone();

                }

                min.min(vertexScreenSpace);
                max.max(vertexScreenSpace);

            }

        } else { // Regular geometry

            for (var i = 0; i < vertices.length; ++i) {

                const vertexWorldCoord = vertex.copy(vertices[i]).applyMatrix4(this.matrixWorld);
                const vertexScreenSpace = vertexWorldCoord.project(camera);

                if (min === undefined) {

                    min = vertexScreenSpace.clone();
                    max = vertexScreenSpace.clone();

                }

                min.min(vertexScreenSpace);
                max.max(vertexScreenSpace);

            }

        }
    }

    // Does this object have children?
    if (this.children !== undefined) {

        for (var i = 0; i < this.children.length; ++i) {

            let box2 = this.children[i].computeScreenSpaceBoundingBox(camera);

            if (min === undefined) {

                // console.log("min undefined", this);

                min = box2.min.clone();
                max = box2.max.clone();

            } else {

                // console.log("min defined", this);

                min.min(box2.min);
                max.max(box2.max);

            }
        }
    }

    // Normalize to Screen Pixels

    // console.log( "halfRenderSize", halfRenderSize );
    // console.log( "random", new Box2( new Vector2( min.x, - min.y ).multiply( halfRenderSize ).add( halfRenderSize ), new Vector2( max.x, max.y ).multiply( halfRenderSize ).add( halfRenderSize ) ) );
    // console.log( "random1", this );

    return new Box2(new Vector2(min.x, min.y), new Vector2(max.x, max.y));
}



Light.prototype.isLight = true;



CameraControls.prototype.normalizeRotationsHalve = function () {
    this._sphericalEnd.theta = this._sphericalEnd.theta % Math.PI;
    if (this._sphericalEnd.theta < 0)
        this._sphericalEnd.theta += Math.PI;
    this._spherical.theta += Math.PI * Math.round((this._sphericalEnd.theta - this._spherical.theta) / Math.PI);
};



Box3.prototype.getSizeAlt = function () {
    return this.getSize(new Vector3());
}



Box3.prototype.getCenterAlt = function () {
    return this.getCenter(new Vector3());
}



Box2.prototype.getSizeAlt = function () {
    return this.getSize(new Vector2());
}



Vector3.prototype.getMax = function () {
    return (this.x > this.y) ? ((this.x > this.z) ? this.x : this.z) : ((this.y > this.z) ? this.y : this.z);
}



$('form.composer').first().submit(function (event) {
    const composer_data = {}

    captureImage();

    object.steps.forEach(step => {
        composer_data[step.uuid] = step.value
    })

    $('<input>').attr({
        type: 'hidden',
        name: 'composer-data',
        value: JSON.stringify(composer_data)
    }).appendTo(this)
})



const carouselItemHeights = []

document.querySelector('.carousel').addEventListener('slide.bs.carousel', function (e) {
    activeStep = e.to;

    if ($("[data-bs-slide-to='" + activeStep + "']").first().hasClass("hide-step")) {
        e.preventDefault()

        const direction = (e.direction == "left") ? 1 : -1
        console.log(e.direction, direction);

        $(this).carousel(activeStep + direction);
    }

    if (window.scrollY > carouselItemHeights[activeStep]) {
        $("html, body").animate({
            scrollTop: carouselItemHeights[activeStep]
        });
    }

    $('.step-indicators').css("--active-step", activeStep);

    $('.step-indicators').children().eq(e.from).removeClass("active");
    $('.step-indicators').children().eq(activeStep).addClass("active");;

    controls.goToStep(activeStep);
    // controls.saveState()


    if (activeStep >= object.steps.length) {
        $("[data-bs-slide='next']").css("display", "none")
        $(".btn-quantity").attr('style', 'display: block !important')
    } else {
        $("[data-bs-slide='next']").css("display", "block")
        $(".btn-quantity").attr('style', 'display: none !important')
    }
});



$('.carousel-inner model-select model-option').on("click", function () {
    const modelSelect = object.steps.find( step => step.uuid == $(this).parent().attr("uuid") );
    modelSelect.value = $(this).children("canvas").first().attr("model-option-uuid");
    modelSelect.models.forEach( model => {
        if (model.uuid != $(this).children("canvas").first().attr("model-option-uuid")) {
            camera.layers.disable(model.layer)
        } else {
            camera.layers.enable(model.layer)
        }
    })

    render();
    renderThumbs();

    controls.fitObject(mesh, true);
    controls.goToStep(activeStep);
});



$('.carousel-inner material-option[type="texture"]').on("click", function () {
    $("html, body").animate({
        scrollTop: 0
    });

    console.log("hey", $(this).data('src') + "_512x512.jpg");

    materials[object.steps[activeStep].materialUuid].map.changeImage(
        $(this).data('src') + "_512x512.jpg",
        () => {
            render()
            renderThumbs()
        }
    );

    const baseUrl = "https://aspersonal.nl/wp-content/themes/aspersonal/composer/materials/" + object.steps[activeStep].library + "/";
    object.steps[activeStep].value = $(this).data('src').replace(baseUrl, "")

    $('.step-indicators material-option[type="texture"].active img').attr("src", $(this).data('src') + "_50x50.jpg")
            render()
});



$('.carousel-inner material-option[type="color"]').on("click", function () {
    $("html, body").animate({
        scrollTop: 0
    });

    let color = $(this).css("--color");

    materials[object.steps[activeStep].materialUuid].changeColor(new Color(color));

    // console.log(new Color(color));

    object.steps[activeStep].value = color
    $('.step-indicators material-option[type="color"].active').css("--color", color);

    render();
    renderThumbs();
});



// $('.carousel-inner material-option[type="texture"]').popover({
//     html: true,
//     trigger: 'hover',
//     content: function () {
//         return `<img src="${$(this).data('src')}_242x200.jpg" />`;
//     },
//     template: '<div class="popover" role="tooltip">' + '<h3 class="popover-header"></h3>' + '<div class="popover-body"></div></div>'
// });



// $.fn.tooltip.Constructor.Default.whiteList['*'].push('style');
// $('.carousel-inner material-option[type="color"]').popover({
//     html: true,
//     trigger: 'hover',
//     html: true,
//     title: function () {
//         return `<span style="color: ${$(this).css("color")}"> ${$(this).data("title")} </span> `
//     },
//     content: function () {
//         return `<div style="width: 242px; height: 200px; background-color: ${$(this).css("--color")};"></div>`
//     },
//     template: '<div class="popover" role="tooltip">' + '<h3 class="popover-header"></h3>' + '<div class="popover-body"></div></div>'
// });



const normalizeMeasureInput = (measure, defaultMeasure, min, max) => {
    measure = parseInt(measure)

    min = parseInt(min)
    max = parseInt(max)

    if (isNaN(measure)) measure = parseInt(defaultMeasure)
    else if (measure < min) measure = min
    else if (measure > max) measure = max

    return measure
}

let previousActiveMeasure;

$('measure-input input').on('input', function () {
    const measure = normalizeMeasureInput($(this).val(), $(this).data("default"), $(this).attr("min"), $(this).attr("max"))

    if (measure != previousActiveMeasure) {

        const direction = $(this).data('direction');

        $('.step-indicators measure-input.active badge').text(measure)
        object.steps[activeStep].value = measure;

        if ("pivot" in object) mesh.scaleObject(measure, direction, Object.assign(new Pivot3, object.pivot))
        else mesh.scaleObject(measure, direction)

        controls.fitObject(mesh, true)

        if ("calculationUuid" in object.steps[activeStep])
            calculatePrice();

        previousActiveMeasure = measure
    }
});

$('measure-input input').on("focusout", function () {
    $(this).val(normalizeMeasureInput($(this).val(), $(this).data("default"), $(this).attr("min"), $(this).attr("max")))
})

let cheekTableBase = 0;
const $price = $("price").first();

const calculatePrice = () => {

    const calculation = object.calculation
    const calcFunction = new Function(...calculation.parameters.map(parameter => parameter.name), calculation.function.join('\n'))

    calculation.parameters.forEach(parameter => console.log(object.steps.find(step => step.uuid == parameter.argumentUuid).value))

    console.log(...(calculation.parameters.map(parameter => object.steps.find(step => step.uuid == parameter.argumentUuid).value)))

    const price = calcFunction(...(calculation.parameters.map(parameter => object.steps.find(step => step.uuid == parameter.argumentUuid).value)));
    console.log("price", price)

    $price.attr("data-price", price)
    $price.text(price.toLocaleString(undefined, {
        maximumFractionDigits: 2
    }))
}



$('quantity-input input').on('input', function () {
    let quantity = parseInt($(this).val())

    if (Number.isNaN(quantity) || quantity < 0) {
        quantity = 1
    }

    $('.step-indicators quantity-input.active quantity-display').text(quantity)
});



$('feature-select feature-option').on("click", function () {

    const imageSrc = $(this).find("img").first().attr("src")
    const name = $(this).find("p").first().text().toLowerCase().trim()

    $('.step-indicators feature-option.active img').attr("src", imageSrc)
    object.steps[activeStep].value = imageSrc

    if (object.steps[activeStep].dependency) {
        // console.log("true" + object.steps[activeStep].dependency.hide + "-" + name + "-")
        if (object.steps[activeStep].dependency.hide == name) {
            // console.log("add");
            $("[data-slug='" + object.steps[activeStep].dependency.slug + "']").addClass("hide-step")
        } else {
            console.log("remove", $("[data-slug='" + object.steps[activeStep].dependency.slug + "']"));
            $("[data-slug='" + object.steps[activeStep].dependency.slug + "']").removeClass("hide-step")
        }
    }

    // if (object.steps[activeStep].price) {
    //     if (name != "geen") {
    //         if (cheekTableBase == 0) {
    //             cheekTableBase = object.steps[activeStep].price;

    //             const price = parseFloat($price.attr("data-price")) + cheekTableBase

    //             $price.attr("data-price", price)
    //             $price.text(price.toLocaleString(undefined, {
    //                 maximumFractionDigits: 2
    //             }))
    //         }
    //     } else {
    //         const price = parseFloat($price.attr("data-price")) - cheekTableBase

    //         $price.attr("data-price", price)
    //         $price.text(price.toLocaleString(undefined, {
    //             maximumFractionDigits: 2
    //         }))

    //         cheekTableBase = 0;
    //     }
    // }

});


var arrowDirection = {
    UP: 0,
    DOWN: 1,
    BOTH: 2
};

// const createArrow = (startPosition, endPosition) => {
//     const arrowPoint = () => {
//         const group = new Group();
//         const coneMesh = new Mesh(new ConeGeometry(.05, .10, 32), new MeshBasicMaterial({
//             color: 0xaa182c
//         }));
//         group.add(coneMesh)
//         // const size = coneMesh.getSizeAlt();

//         // coneMesh.position.set();
//         const sphere = new Mesh(new SphereGeometry(.01, 32, 32), new MeshBasicMaterial({
//             color: 0xaa182c
//         }));
//         group.add(sphere)
//         return group
//     }

//     scene.add(arrowPoint());
// }



// Clone Context2D To Another Canvas
HTMLCanvasElement.prototype.copyFromCanvas = function (sourceCanvas) {
    const thisContext2D = this.getContext('2d')

    thisContext2D.clearRect(0, 0, this.width, this.height)

    thisContext2D.drawImage(sourceCanvas, 0, 0, sourceCanvas.width, sourceCanvas.height, 0, 0, this.width, this.height)

}
// End Clone Context2D To Another Canvas



String.prototype.sanitize = function () {
    return this.replace(/[^a-z0-9áéíóúñü \.,_-]/gim, "").trim()
}

Box2.prototype.normalizeToPixels = function (renderer) {

    const normalizedBox2 = this.clone()

    const halfRenderSize = new Vector2(renderer.domElement.offsetWidth / 2, renderer.domElement.offsetHeight / 2)
    normalizedBox2.min.multiply(halfRenderSize).add(halfRenderSize)
    normalizedBox2.max.multiply(halfRenderSize).add(halfRenderSize)

    return normalizedBox2
}

// Capture Image
let otherItemInCartWithSameConfig = false;

function captureImage() {

    const objectBoundingBoxToScreen = mesh.computeScreenSpaceBoundingBox(camera).normalizeToPixels(renderer);
    const objectSize = objectBoundingBoxToScreen.getSizeAlt();

    const croppedCanvas = document.createElement('canvas');
    const croppedCanvasContext = croppedCanvas.getContext('2d');

    croppedCanvas.width = objectSize.width + 60;
    croppedCanvas.height = objectSize.height + 60;

    croppedCanvasContext.drawImage(renderer.domElement, objectBoundingBoxToScreen.min.x - 30, objectBoundingBoxToScreen.min.y - 30, objectSize.width + 60, objectSize.height + 60, 0, 0, objectSize.width + 60, objectSize.height + 60);

    let imageIdInput = $('[name="composer-image"]').first();

    let configurationId = "";

    object.steps.forEach(step => {
        configurationId += step.value
    })

    configurationId = configurationId.sanitize();

    otherItemInCartWithSameConfig = Object.keys(localStorage).includes(configurationId)

    if (!otherItemInCartWithSameConfig) {
        localStorage.removeItem(imageIdInput.val())
    }

    localStorage.setItem(configurationId, croppedCanvas.toDataURL())
    imageIdInput.val(configurationId);

}
// End Capture Image



// Utils Needed for BloomingShaderPass
var darkMaterial = new MeshBasicMaterial({
    color: "black"
});
var opaqueMaterial = new MeshBasicMaterial({
    color: "black",
    transparent: true
});
const materials_copy = {};
// End Utils Needed for BloomingShaderPass



// Darken Non Bloomed Items
const darkenNonBloomed = obj => {

    if (obj.isMesh && bloomLayer.test(obj.layers) === false) {

        materials_copy[obj.uuid] = obj.material;
        if (!obj.material.transparent) {
            obj.material = darkMaterial;
        } else {
            opaqueMaterial.opacity = obj.material.opacity
            obj.material = opaqueMaterial;
        }

    }
    // else if ( obj.isMesh ) {
    //     console.log( "isBlooming", obj );
    // }

}
// End Darken Non Bloomed Items


// Restore Visibility States
const restoreMaterial = obj => {

    if (materials_copy[obj.uuid]) {

        obj.material = materials_copy[obj.uuid];
        delete materials_copy[obj.uuid];

    }

}
// Restore Visibility States




// // Add new Chain Item
// $('.add-extra-object').on("click", function ( e ) {
//     console.log( "random1223456", mesh );
//     $('.tab-content:').first().
//     e.preventDefault()
//     // $(this).tab('show')
// })



// window.onbeforeunload = function(){
//     return "";
// };



let hsl = {
    h: 0,
    s: 0,
    l: 0
}


$("hue-slider")
    .on("pointerdown", hueSlider_pointermove)
    .on("pointerdown", function () {
        $(window).on("pointermove", hueSlider_pointermove);
    })
$(window).on('pointerup', function () {
    $(this).off("pointermove", hueSlider_pointermove);
})

function hueSlider_pointermove(e) {

    e.preventDefault();

    let percentX = 0;

    let targetBoundingBox = {
        left: $("hue-slider").offset().left,
        right: $("hue-slider").offset().left + $("hue-slider").outerWidth()
    }

    if (e.clientX > targetBoundingBox.left && e.clientX < targetBoundingBox.right) {
        percentX = e.clientX.map(targetBoundingBox.left, targetBoundingBox.right, 0, 100)
    } else if (e.clientX > targetBoundingBox.right) {
        percentX = 100;
    }

    $("hue-slider").find("thumb").css({
        "left": percentX + "%",
        "background": "hsl(" + percentX * 3.6 + ", 100%, 50%)"
    });

    filterRalColors(percentX * 3.6);
}

function filterRalColors(hue) {
    $('.carousel-item.active material').parent().css('display', 'none');
    $('.carousel-item.active material').filter(function () {

        let lowerBound = (hue - 15);
        if (lowerBound < 0) lowerBound += 360;

        let upperBound = (hue + 15) % 360;

        console.log("lower ", lowerBound, " - upper ", upperBound);

        return $(this).data('hue') > lowerBound && $(this).data('hue') < upperBound;
    })
        .parent().css('display', 'block');
}

Number.prototype.map = function (in_min, in_max, out_min, out_max) {
    return (this - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
}


// Translation from Center
//
// https://discourse.threejs.org/t/get-pivot-point-translation-of-an-object3d/6343

// Geometry.prototype.translateFromCenter();